import { Spin, Modal, PageHeader, Tag, Row, Button, Space } from 'antd'
import { FileTextOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import service from '../../../../@services'
import './index.less'
import ProductTable from '../ProductTable'
import BasicDescription from '../BasicDescription'
import { connect } from 'react-redux'

const PopupAfterSale = props => {
  const {
    orderStatus,
    orderType,
    visible,
    onClose,
    detail = {},
    toOrderDetail = () => {}
  } = props
  console.log(orderType)
  const [loading, setLoading] = useState(false)
  const [orderDetail, setOrderDetail] = useState({})
  /** 基本信息描述字段及组件列表 */
  const fileds = [
    {
      label: '订单类型',
      value: 'orderTypeName',
      render: (text, record) => {
        if (text) return text
        return (
          (
            (orderType || []).filter(
              item => item.code == record.orderType
            )[0] || []
          ).name || record.orderType
        )
      }
    },
    { label: '下单时间', value: 'orderTime' },
    {
      label: '支付方式',
      value: 'payWays',
      render: text => text && text.join(',')
    },
    { label: '售后状态', value: 'aftersaleStatusName' },
    { label: '创建时间', value: 'aftersaleTime' },
    {
      label: '退款时间',
      value: 'refundTimes',
      span: 2,
      contentStyle: { flexDirection: 'column' },
      render: text => text && text.map(item => <div key={item}>{item}</div>)
    },
    {
      label: '售后类型',
      value: 'aftersaleTypeName'
    },
    {
      label: '退款方式',
      value: 'refundWays',
      render: text => text && text.join(',')
    },
    {
      label: '退款状态',
      value: 'orderStatusName'
    },
    { label: '配送方式', value: 'receiveWay' },
    { label: '购买人姓名', value: 'buyerName' },
    { label: '联系方式', value: 'buyerPhone' }
  ]
  useEffect(() => {
    setLoading(true)
    if (visible && detail.aftersaleNo) {
      service.order
        .getAfterSaleDetail(detail.aftersaleNo)
        .then(data => {
          setOrderDetail(data || {})
          setLoading(false)
        })
        .catch(e => {
          setLoading(false)
        })
    } else {
      setLoading(false)
      setOrderDetail({})
    }
  }, [visible])
  return (
    <Modal
      title='售后详情'
      centered
      footer={null}
      visible={visible}
      onCancel={onClose}
      width={1000}
      className='aftersale-detail-popup'>
      <Spin spinning={loading}>
        <PageHeader
          title={
            <>
              <FileTextOutlined
                style={{ color: '#1890FF', marginRight: '5px' }}
              />
              <span style={{ color: '#1890FF' }}>
                售后单号：{orderDetail.aftersaleNo}
              </span>
            </>
          }
          tags={
            orderDetail.aftersaleStatusName && (
              <Tag color='green'>{orderDetail.aftersaleStatusName}</Tag>
            )
          }
          extra={
            <span>
              关联订单：
              <span
                style={{
                  color: '#1890FF',
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
                onClick={toOrderDetail}>
                {orderDetail.orderNo}
              </span>
            </span>
          }
          className='detail-head-white'></PageHeader>
        <PageHeader className='detail-head' title='订单基础信息'>
          <BasicDescription
            detail={orderDetail}
            fileds={fileds}
            column={{ xs: 1, sm: 2, md: 3 }}
          />
        </PageHeader>
        <PageHeader
          className='detail-head'
          title='商品信息'
          extra={
            <Row>
              共
              <span className='primary-text'>
                {orderDetail.aftersaleProductCount || 0}
              </span>
              种商品，总金额
              <span className='primary-text'>
                {orderDetail.refundProductAmount || 0}
              </span>
              元， 实退金额
              <span className='primary-text'>
                {orderDetail.refundAmount || 0}
              </span>
              元
            </Row>
          }>
          <ProductTable data={orderDetail.details || []} isAfterSale />
          <div className='detail-row'>
            <span>商品总金额</span>
            <span>￥{orderDetail.refundProductAmount || 0}</span>
          </div>
          <div className='detail-row'>
            <span>包装费</span>
            <span>￥{orderDetail.refundPackageAmount || 0}</span>
          </div>
          <div className='detail-row'>
            <span>配送费</span>
            <span>￥{orderDetail.freightAmount || 0}</span>
          </div>
          <div className='detail-row right'>
            <span>实退金额</span>
            <span style={{ marginLeft: '20px' }}>
              ￥{orderDetail.refundAmount || 0}
            </span>
          </div>
        </PageHeader>
      </Spin>
    </Modal>
  )
}
export default connect(state => ({
  orderStatus: state.order.orderStatus,
  orderType: state.order.orderType
}))(PopupAfterSale)
